export enum TAILWIND_BREAKPOINTS {
  SM = "SM",
  MD = "MD",
  LG = "LG",
  XL = "XL",
  XXL = "2XL"
}

export const TAILWIND_BREAKPOINTS_WIDTH: { [key in TAILWIND_BREAKPOINTS]: number } = {
  [TAILWIND_BREAKPOINTS.SM]: 640,
  [TAILWIND_BREAKPOINTS.MD]: 768,
  [TAILWIND_BREAKPOINTS.LG]: 1024,
  [TAILWIND_BREAKPOINTS.XL]: 1280,
  [TAILWIND_BREAKPOINTS.XXL]: 1536
};
